import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.RatingModal
* Encapsulates the functionality of a modal dialog that contains rating warning.
**/
HSN.RatingModal = (function (_super) {
    __extends(RatingModal, _super);

    function RatingModal() {
        return RatingModal.__super__.constructor.call(this);
    }


    RatingModal.prototype._show = function (rating, buttonClicked) {

        $.ajax(
            "/esrb/notice/rating?" + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                data: { 'rating': rating },
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml(
                        data,
                        0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                        },
                        function () {
                            //__scope.Center();
                        }
                    );


                    $('#under17').on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        var exdate = new Date();
                        exdate.setDate(exdate.getDate() - 1);
                        var c_value = escape("true") + ((1 == null) ? "" : "; expires=" + exdate.toUTCString());
                        document.cookie = "over17=" + c_value;

                        __scope.Root.hide();
                        $('#modal-mask').remove();
                    });

                    $('#over17').on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        var exdate = new Date();
                        var c_value = escape("true");
                        document.cookie = "over17=" + c_value;


                        __scope.Root.hide();
                        $('#modal-mask').remove();

                        buttonClicked.click();
                    });

                    //base modal wasn't working so this fixes that.
                    $('.close').on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        __scope.Root.hide();
                        $('#modal-mask').remove();
                    });

                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );




    };

    return RatingModal;
})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/RatingModal.js